var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row my-2"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"font-weight-bold"},[_vm._v("Quote Id: "+_vm._s(_vm.quoteNumber))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }